import { render, staticRenderFns } from "./contribute.vue?vue&type=template&id=282d2af3&scoped=true"
import script from "./contribute.vue?vue&type=script&lang=js"
export * from "./contribute.vue?vue&type=script&lang=js"
import style0 from "./contribute.vue?vue&type=style&index=0&id=282d2af3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "282d2af3",
  null
  
)

export default component.exports